import MainLayout from "layouts/Main";
import { settingsTabs } from "views/Dashboard/Settings/tabs";
import ClientGroupsTable from "./ClientGroupsTable";

const ClientGroups = () => {
  return (
    <MainLayout tabs={settingsTabs}>
      <ClientGroupsTable />
    </MainLayout>
  );
};

export default ClientGroups;
